export default __webpack_public_path__ + "static/media/4.22f36753.png";